const hidde_scrollbar = () => {
    // 隐藏页面滚动条
    const m = window.innerWidth - document.body.clientWidth // 滚动条的宽度
    document.documentElement.style.marginRight = m + 'px'
    document.documentElement.style.overflowY = 'hidden'
}

const show_scrollbar = () => {
    // 显示页面滚动条
    document.documentElement.style.marginRight = '0px'
    document.documentElement.style.overflowY = 'auto'
}

const preFetch = (list) => {
    // 空闲时，加载即将会用到的资源
    for (let i = 0, len = list.length; i < len; i++) {
        const link = document.createElement("link");
        link.rel = "prefetch";
        link.href = list[i];
        document.head.appendChild(link);
    }
}

const preload = (list) => {
    // 强制浏览器先请求资源
    for (let i = 0, len = list.length; i < len; i++) {
        const link = document.createElement("link");
        link.rel = "preload";
        link.as = list[i].as;
        link.href = list[i].url;
        if (list[i].as === "font") {
            // 请求字体时需要使用匿名的跨域模式
            link.crossOrigin = "";
        }
        document.head.appendChild(link);
    }
}

const isPC = () => {
    // 判断设备是否是pc
    const userAgentInfo = navigator.userAgent;
    const Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
    );
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

const checkEmail = (email) => {         // 验证邮箱格式是否正确
    const reg = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return reg.test(email);
}
export default {
    hidde_scrollbar,
    show_scrollbar,
    preFetch,
    preload,
    isPC,
    checkEmail
}